import React from 'react';
import { Box } from '@mui/material';
import { spacing } from 'common/theme';
import { TextHot } from 'components/common/TextHot';
import { IconHot } from 'components/common/IconHot';

export const EmptyDataHot = ({ 
  title, 
  image, 
  imageSize = 160, 
  testID = 'empty-data-container' 
}) => {
  return (
    <Box
      testId={testID}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: `${spacing.xxl}px`,
        textAlign: 'center',
        width: '100%',
        minHeight: 300,
      }}
    >
      {image && (
        <Box 
          testId={`${testID}-image-wrapper`}
          sx={{ marginBottom: `${spacing.lg}px` }}
        >
          <IconHot 
            src={image} 
            size={imageSize} 
          />
        </Box>
      )}

      <TextHot
        testID={`${testID}-title`}
        size="xxxxl"
        bold="bold"
        color="primary"
      >
        {title}
      </TextHot>
    </Box>
  );
};

export default EmptyDataHot;